export const frontmatter = {
    "draft": false,
    "title": "Administración",
    "sidebar_group": "referencia",
    "sidebar_label": "Administración",
    "sidebar_order": 1
}

export const toc = []